import React from "react";
import { CreatePromoterForm } from "../components/CreatePromoterForm";

const CreatePromoterPage = () => {
  return <CreatePromoterForm />;
};

export default CreatePromoterPage;
